import { Box, Slider, Stack, Typography } from "@mui/material";
import { formatNumber } from "../roiUtils";

interface SliderFieldProps {
  label: string;
  min: number;
  max: number;
  step?: number;
  unit: string;
  language: string;
  value: number;
  onChange: (value: number) => void;
}

export default function SliderField({
  label,
  min,
  max,
  step = 1,
  unit,
  language,
  value,
  onChange,
}: SliderFieldProps) {
  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
        <Typography color="text.secondary" fontWeight={700}>
          {label}
        </Typography>
        <Typography
          fontWeight={800}
          whiteSpace="nowrap"
          sx={{
            color: (theme) =>
              theme.palette.mode === "dark" ? "primary.main" : "secondary.main",
          }}
        >
          {formatNumber(value, language)} {unit}
        </Typography>
      </Stack>
      <Slider
        min={min}
        max={max}
        step={step}
        value={value}
        aria-label={label}
        onChange={(_, nextValue) => onChange(nextValue as number)}
        sx={{
          mt: 1,
          color: "primary.main",
          "& .MuiSlider-thumb": {
            border: "3px solid",
            borderColor: "background.paper",
            boxShadow: "0 2px 10px rgba(30, 53, 95, 0.2)",
          },
        }}
      />
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="caption" color="text.secondary">
          {formatNumber(min, language)} {unit}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {formatNumber(max, language)} {unit}
        </Typography>
      </Stack>
    </Box>
  );
}
